import { Grid } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { MainContainer, AmountsBlock, Amounts, AmountBlock, AmountTitle } from "./styles";
import { DocumentDTO } from "../../../../../../../../../models/documents";
import { EmployeeRef } from "../../../../../../../../../models/employees";
import { TravelExpenseAuditNotesDTO } from "../../../../../../../../../models/travel-expense-audit-notes";
import { TravelExpenseRef } from "../../../../../../../../../models/travel-expenses";
import AuditNotes from "../../AuditNotesActions/AuditNotes/AuditNotes";
import ReceiptStatus from "../../ReceiptComponents/ReceiptStatus/ReceiptStatus";

interface Props {
  travelExpense: TravelExpenseRef;
  employee: EmployeeRef;
  handleNotifyParent: (document: DocumentDTO | null) => void;
  defaultTravelExpense: TravelExpenseRef;
  disabledAuditActions: boolean;
  updateLastAuditNote: (auditNote: TravelExpenseAuditNotesDTO) => void;
  hideAuditNotes: boolean;
  isManagedByLink?: boolean;
}

const InfoAndNotesSection = ({
  travelExpense,
  employee,
  handleNotifyParent,
  defaultTravelExpense,
  disabledAuditActions,
  updateLastAuditNote,
  hideAuditNotes,
  isManagedByLink,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.add_edit_travel_expense";

  return (
    <MainContainer>
      <ReceiptStatus auditAccepted={travelExpense.auditAccepted} />

      <AmountsBlock>
        <Grid flex={1}>
          <AmountTitle>{`${t(`${tRP}.fields.accepted_amount`)}`}:</AmountTitle>
        </Grid>
        <AmountBlock flex={1}>
          <Amounts
            aceeptedAmount
            title={`${t(`${tRP}.fields.accepted_amount`)}: ${travelExpense.acceptedAmount.toLocaleCustom()} ${
              travelExpense.currency?.code ?? ""
            }`}
          >{`${travelExpense.acceptedAmount.toLocaleCustom()} ${travelExpense.currency?.code ?? ""}`}</Amounts>
        </AmountBlock>
      </AmountsBlock>

      <AmountsBlock>
        <Grid flex={1}>
          <AmountTitle>{`${t(`${tRP}.fields.difference`)}`}:</AmountTitle>
        </Grid>
        <AmountBlock flex={1}>
          <Amounts
            title={`${t(`${tRP}.fields.difference`)}: ${travelExpense.difference.toLocaleCustom()} ${
              travelExpense.currency?.code ?? ""
            }`}
          >{`${travelExpense.difference.toLocaleCustom()} ${travelExpense.currency?.code ?? ""}`}</Amounts>
        </AmountBlock>
      </AmountsBlock>

      <>
        {!!defaultTravelExpense.auditNotes.length && !hideAuditNotes && (
          <>
            {/* <AuditDocument
              travelExpense={travelExpense}
              document={travelExpense.auditDocument}
              employee={employee}
              handleNotifyParent={handleNotifyParent}
              readOnly={disabledAuditActions}
              customTitleStyle={{
                fontWeight: "bold",
                color: "inherit",
              }}
            /> */}

            <AuditNotes
              employee={employee}
              travelExpense={defaultTravelExpense}
              legalEntity={employee?.legalEntity ?? defaultTravelExpense?.legalEntity}
              readOnly={disabledAuditActions}
              updateLastAuditNote={updateLastAuditNote}
              textInsteadChipTitle
              isManagedByLink={isManagedByLink}
            />
          </>
        )}
      </>
    </MainContainer>
  );
};

export default InfoAndNotesSection;
